// extracted by mini-css-extract-plugin
export var downArrow = "_7b-0";
export var infoTooltipIcon = "_7b-3";
export var label = "_7b-1";
export var optionCard = "_7b-4";
export var upArrow = "_7b-2";